export const setEnvironment = (environment) => {
    localStorage.setItem('environment', environment);
};

export const getEnvironment = () => {
    const environment = window.location.hostname === "localhost"
        ? "DEV"
        : window.location.hostname.endsWith(".web.app")
            ? "STAGING"
            : "PROD";

    return localStorage.getItem('environment') || environment;
};